import {
  TravelTimeIcon,
  ConnectivityIcon,
  CurrencyIcon,
  AvgCostIcon,
  VisaIcon,
  DrinkWaterIcon,
  HazardsIcon,
  CardsIcon,
} from '../components/Icons';

const handleText = (text: string) => {
  const splittedText = text.split(/\r?\n/);
  const filteredText = splittedText.filter((el) => el !== '');
  return filteredText;
};

const quickTipElement = (key: string, val: string) => {
  switch (key) {
    case 'travelTimes':
      return {
        icon: TravelTimeIcon,
        title: 'Travel Time',
        content: handleText(val),
      };
    case 'connectivity':
      return {
        icon: ConnectivityIcon,
        title: 'Connectivity',
        content: handleText(val),
      };
    case 'currency':
      return {
        icon: CurrencyIcon,
        title: 'Currency',
        content: handleText(val),
      };
    case 'averageCost':
      return {
        icon: AvgCostIcon,
        title: 'Avg. cost of...',
        content: handleText(val),
      };
    case 'visaRequirements':
      return {
        icon: VisaIcon,
        title: 'Visa Requirements',
        content: handleText(val),
      };
    case 'drinkingWaterQuality':
      return {
        icon: DrinkWaterIcon,
        title: 'Drinking water quality',
        content: handleText(val),
      };
    case 'hazards':
      return {
        icon: HazardsIcon,
        title: 'Hazards',
        content: handleText(val),
      };
    case 'cashCardCrypto':
      return {
        icon: CardsIcon,
        title: 'Cash, card, crypto',
        content: handleText(val),
      };
    default:
      return null;
  }
};

export default quickTipElement;
